import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '导航分类',
      links: [
        { label: '综合门户', to: '/category/zonghe-menhu' },
        { label: '搜索引擎', to: '/category/sousuo-yinqing' },
        { label: '社交媒体', to: '/category/shejiao-meiti' },
        { label: '视频娱乐', to: '/category/shipin-yule' },
        { label: '购物消费', to: '/category/gouwu-xiaofei' },
      ],
    },
    {
      title: '常用推荐',
      links: [
        { label: '学习教育', to: '/category/xuexi-jiaoyu' },
        { label: '新闻资讯', to: '/category/xinwen-zixun' },
        { label: '工具资源', to: '/category/gongju-ziyuan' },
        { label: '生活服务', to: '/category/shenghuo-fuwu' },
        { label: '科技IT', to: '/category/keji-it' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', to: '/about' },
        { label: '口碑声誉', to: '/about' },
        { label: '联系我们', to: '/about' },
        { label: '资讯文章', to: '/article/1' },
      ],
    },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-compass-3-line text-2xl text-primary-500"></i>
              </div>
              <span className="text-lg font-bold text-foreground-950">{t('siteName')}</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('footerDescription')}
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            {t('copyright').replace('2026', String(currentYear))}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">使用条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}